import {Company} from '@legit-health/ui';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MenuBook from '@mui/icons-material/MenuBook';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import {Condition} from '@/patient/interfaces/Condition';
import patientPaths from '@/patient/routing/paths';
import EncountersIcon from '@/shared/components/ui/icons/EncountersIcon';
import EvolutionIcon from '@/shared/components/ui/icons/EvolutionIcon';
import {USER_HOME} from '@/shared/routing/paths';

const menuItems = (company: Company, conditions: Condition[], canUploadPhotos: boolean) => {
  if (company.isForClinicalTrials) {
    return [
      {
        name: 'patient/common:menu.diagnosticReports',
        link: patientPaths.IMAGE_PROTOCOLS,
        icon: <EvolutionIcon />,
        id: 'menuEvolution'
      },
      {
        name: 'patient/common:menu.dashboard',
        link: USER_HOME,
        icon: <DashboardIcon />,
        id: 'menuPanel'
      }
    ];
  }

  return [
    ...(canUploadPhotos
      ? [
          {
            name: 'patient/common:menu.encounters',
            link: patientPaths.PATIENT_ENCOUNTER_LIST,
            icon: <EncountersIcon />,
            id: 'menuEncounters'
          },
          {
            name: 'patient/common:menu.upload',
            link: patientPaths.DIAGNOSTIC_REPORT_REQUEST,
            icon: <AddAPhotoIcon />,
            id: 'menuUpload'
          }
        ]
      : []),
    {
      name: 'patient/common:menu.diagnosticReports',
      link: patientPaths.DIAGNOSTIC_REPORTS,
      icon: <EvolutionIcon />,
      id: 'menuEvolution'
    },
    {
      name: 'patient/common:menu.documents',
      link: patientPaths.DOCUMENT_LIST,
      icon: <UploadFileIcon />,
      id: 'uploadDocument'
    },
    {
      name: 'patient/common:menu.dashboard',
      link: USER_HOME,
      icon: <DashboardIcon />,
      id: 'menuPanel'
    },
    ...(conditions.find((c) => c.pathology.code === 'Psoriasis')
      ? [
          {
            name: 'patient/common:menu.psoriasis',
            link: patientPaths.PSORIASIS_INFO,
            icon: <MenuBook />,
            id: 'menuPsoriasis'
          }
        ]
      : [])
  ];
};

export default menuItems;
